import { createAction } from 'typesafe-actions'

import { Id } from 'src/types'

import {
  ResourcesActionTypes,
  ResourcesAvailable,
  ResourcesHttpData
} from './types'

interface GetResourcesOptions {
  allowAll?: boolean
  organization_id?: Id
  page_size?: number
  page?: number
  search?: string
}

export const addResource = createAction(
  ResourcesActionTypes.ADD_RESOURCE,
  action =>
    (
      resource: keyof ResourcesAvailable,
      item: ResourcesAvailable[keyof ResourcesAvailable]
    ) =>
      action({ resource, item })
)

export const finishLoader = createAction(
  ResourcesActionTypes.FINISH_LOADER,
  action => (resource: keyof ResourcesAvailable) => action({ resource })
)
/**
 * the resource
 * options for filters
 * isEdit when is admin pages
 */
export const getResources = createAction(
  ResourcesActionTypes.GET_RESOURCES,
  action =>
    (
      resource: keyof ResourcesAvailable,
      options?: GetResourcesOptions,
      isEdit?: boolean
    ) =>
      action({ options, resource, isEdit })
)

export const getResourcesSuccess = createAction(
  ResourcesActionTypes.GET_RESOURCES_SUCCESS,
  action =>
    <K extends keyof ResourcesAvailable>({
      allowAll,
      list,
      organization_id,
      page,
      resource,
      total_pages,
      total_results
    }: {
      allowAll?: boolean
      list: ResourcesHttpData[K]
      organization_id: Id
      page: number
      resource: K
      total_pages: number
      total_results: number
    }) =>
      action({
        allowAll,
        list,
        organization_id,
        page,
        resource,
        total_pages,
        total_results
      })
)

export const getResourcesFailure = createAction(
  ResourcesActionTypes.GET_RESOURCES_FAILURE,
  action => (resource: keyof ResourcesAvailable) => action({ resource })
)

export const reloadResourcesPage = createAction(
  ResourcesActionTypes.RELOAD_RESOURCES_PAGE,
  action => (resource: keyof ResourcesAvailable) => action({ resource })
)

export const reloadResourcesPageFailure = createAction(
  ResourcesActionTypes.RELOAD_RESOURCES_PAGE_FAILURE,
  action => (resource: keyof ResourcesAvailable, page: number) =>
    action({ resource, page })
)

export const setResources = createAction(
  ResourcesActionTypes.SET_RESOURCES,
  action =>
    (
      resource: keyof ResourcesAvailable,
      values: ResourcesAvailable[keyof ResourcesAvailable][]
    ) =>
      action({ resource, values })
)

export const setResourcesSuccess = createAction(
  ResourcesActionTypes.SET_RESOURCES_SUCCESS,
  action =>
    (
      resource: keyof ResourcesAvailable,
      value: ResourcesAvailable[keyof ResourcesAvailable]
    ) =>
      action({ resource, value })
)

export const setResourcesFailure = createAction(
  ResourcesActionTypes.SET_RESOURCES_FAILURE,
  action => (resource: keyof ResourcesAvailable) => action({ resource })
)
